import React from "react";
import { useState, useEffect, useRef } from "react";
import {
	Typography,
	Stack,
	Box,
	Table,
	TableBody,
	TableRow,
	TableHead,
	TablePagination,
	TextField,
	Tooltip,
	Popper,
} from "@mui/material";
import {
	StyledTableContainer,
} from "../../components/ui/Table";
// import { StyledTextBox } from "../../components/TextBox";
import { LoadingBox } from "../../components/ui/Box";
import { StyledTableCellBody, StyledTableCellHeader } from "../../components/ui/Table";
// import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import CircularProgress from "@mui/material/CircularProgress";
import { GetTransactionBreakdown } from "../../services/reports.services";
import { formatCurrency } from "../../utils/utilityFunctions";
import moment from "moment";
import { LightBlueContainedButton, TextButton } from "../../components/ui/Buttons";
import { FilterAlt } from "@mui/icons-material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CloseIcon from "@mui/icons-material/Close";
import TableSelection from '@pxlwidgets/table-selection';
import ExcelExport from "../../components/shared/ExcelExport";
import { useLocation } from "react-router-dom";
import { sortByCreatedDateTime } from "../../utils/sortBy";


export default function VepayFee({ props }) {
	let data = useLocation();
	const queryParams = new URLSearchParams(data.search);

	let reportStartDate = moment(localStorage.getItem("factorStartDate")).toDate();
	let reportEndDate = moment().toDate();

	const [isLoading, setIsLoading] = useState(false);
	const [vepayFeeReport, setVepayFeeReport] = useState(null);
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [startDate, setStartDate] = useState(queryParams.get('requestdate') ? moment(queryParams.get('requestdate')).toDate() : reportStartDate);
	const [endDate, setEndDate] = useState(queryParams.get('requestdate') ? moment(queryParams.get('requestdate')).toDate() : reportEndDate);
	const [startDateError, setStartDateError] = useState(false);
	const [endDateError, setEndDateError] = useState(false);
	const [value, setValue] = useState([startDate, endDate]); //state of date picker in filter
	const [filter, setFilter] = useState(null); //state of the filter
	const [totalCount, setTotalCount] = useState(0);

	const hasRun = useRef(false);

	useEffect(() => {
		if (hasRun.current) return;
		hasRun.current = true;

		const fetchData = async () => {
			setIsLoading(true);
			try {
				const data = await GetTransactionBreakdown("Net Sales - Vepay Fee", value[0], value[1], page + 1, rowsPerPage);
				const items = Array.isArray(data) ? data : (data.elements || data.content || data.data || data.items || []);
				const count = Array.isArray(data) ? -1 : (data.totalElements || data.totalCount || data.total || -1);
				setVepayFeeReport(items);
				setTotalCount(count);
			} catch (error) {
				console.error('Error', error);
			} finally {
				setIsLoading(false);
			}
		};
		fetchData();
	}, [props, value, startDate, endDate, page, rowsPerPage]);

	const getExportData = async () => {
		try {
			const data = await GetTransactionBreakdown("Net Sales - Vepay Fee", value[0], value[1]);
			const items = Array.isArray(data) ? data : (data.elements || data.content || data.data || data.items || []);
			return sortByCreatedDateTime(items).map((row) => ({
				"Date": moment(row.createdDate).format("L"),
				"Description": row.description,
				"Order ID": row.ref1?.replace("AMAZON+", ""),
				"Net Sales ($)": Number(row.amount2?.toFixed(2)),
				"%": '2%',
				"VePay Fee ($)": Number(row.amount?.toFixed(2)),
			}));
		} catch (error) {
			console.error('Error fetching export data', error);
			return [];
		}
	};

	if (!vepayFeeReport)
		return (
			<LoadingBox>
				<CircularProgress />
			</LoadingBox>
		);

	const handleChangePage = (event, newPage) => {
		hasRun.current = false;
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		hasRun.current = false;
		setRowsPerPage(+event.target.value);
		setPage(0);
	};

	const handleFilter = () => {
		hasRun.current = false;
		setValue([startDate, endDate]);
		handleCloseMP();
	};

	const handlerFilterReset = () => {
		hasRun.current = false;
		setStartDate(reportStartDate);
		setEndDate(new Date());
		setValue(reportStartDate, new Date());
		handleCloseMP();
	};

	const handleClickMP = (event) => {
		setFilter(event.currentTarget);
	};

	const handleCloseMP = () => {
		setFilter(null);
	};

	const openMP = Boolean(filter);
	const idMP = openMP ? "simple-popover" : undefined;

	const tableSelect = new TableSelection({ selector: 'table' });

	return (
		<div>
			{/* <iframe
      width="600"
      height="3954"
      src="https://lookerstudio.google.com/embed/reporting/7964bf3e-6158-479f-be9d-3c5c791d920f/page/cCtFE"
      frameBorder="0"
      style={{ border: 0 }}
      allowFullScreen
      sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
      title="Looker Studio Report"
    /> */}
			<Box
				sx={{
					p: 3,
					backgroundColor: "#FFFFFF",
					boxShadow: "0px 0px 4px rgba(3, 40, 120, 0.18)",
					borderRadius: "2px",
				}}
			>
				<Stack
					direction="row"
					justifyContent="space-between"
					alignItems="flex-end"
				>
					<Stack direction="row" alignItems="center" spacing={2}>
						<Typography variant="h4">VePay Fee Report</Typography>
						<Typography variant="body2">
							Time period {moment(value[0]).format("MMM D, y")} -&nbsp;
							{moment(value[1]).format("MMM D, y")}
						</Typography>
					</Stack>
					<Stack direction="row" alignItems="center" spacing={2}>
						<Tooltip title="Filter Report">
							<TextButton variant="text" onClick={handleClickMP}>
								<FilterAlt />
							</TextButton>
						</Tooltip>
						<Tooltip title="Export Data to Excel">
							<span>
								<ExcelExport
									filename={
										`VePay Fee Report from ${moment(value[0]).format("MMM D, y")} to ${moment(value[1]).format("MMM D, y")}`
									}
									getExcelData={getExportData}
								/>
							</span>
						</Tooltip>
					</Stack>
				</Stack>
				{/* <br></br> */}
				<Popper
					id={idMP}
					open={openMP}
					anchorEl={filter}
					onClose={handleCloseMP}
					placement={'bottom-end'}
					sx={{ p: 2, bgcolor: 'background.paper', width: "25%", boxShadow: "0px 0px 4px rgba(3, 40, 120, 0.18)", }}
				>
					<Stack
						direction="row"
						justifyContent="space-between"
						spacing={2}
						alignItems="center"
					>
						<Typography sx={{ p: 2 }} variant="h5">
							<b>Filter Report</b>
						</Typography>
						<CloseIcon onClick={handleCloseMP} />
					</Stack>
					<br></br>
					<LocalizationProvider dateAdapter={AdapterDateFns}>
						<div>
							<Stack sx={{ width: "100%" }} spacing={2}>
								<DatePicker
									openTo="day"
									views={["year", "month", "day"]}
									label="Start"
									value={startDate}
									maxDate={endDate}
									onChange={(newValue) => {
										setStartDate(newValue);
									}}
									renderInput={(params) => (
										<>
											{setStartDateError(params.error)}
											<TextField {...params} helperText={null} />
										</>
									)}
								/>
								<DatePicker
									openTo="day"
									views={["year", "month", "day"]}
									label="End"
									value={endDate}
									minDate={startDate}
									onChange={(newValue) => {
										setEndDate(newValue);
									}}
									renderInput={(params) => (
										<>
											{setEndDateError(params.error)}
											<TextField {...params} helperText={null} />
										</>
									)}
								/>
							</Stack>
						</div>
					</LocalizationProvider>
					<br></br>
					<br></br>
					<Stack direction="row" spacing={2}>
						{startDateError === false && endDateError === false ? (
							<LightBlueContainedButton
								fullWidth
								variant="outlined"
								onClick={handleFilter}
								size="large"
							>
								Filter
							</LightBlueContainedButton>
						) : (
							<LightBlueContainedButton fullWidth variant="outlined" disabled>
								Apply
							</LightBlueContainedButton>
						)}
						<LightBlueContainedButton
							fullWidth
							variant="contained"
							onClick={handlerFilterReset}
							size="large"
						>
							Reset
						</LightBlueContainedButton>
					</Stack>
				</Popper>
				{/* <br></br> */}
				{/*  <Stack
					direction="row"
					justifyContent="space-between"
					alignItems="center"
				>
					 <Stack direction="row" spacing={2}>
						<StyledTextBox variant="outlined" placeholder="Search" />
						<LightBlueContainedButton variant="contained">
							Since joining &nbsp; <KeyboardArrowDownOutlinedIcon />
						</LightBlueContainedButton>
						<LightBlueContainedButton variant="contained">
						 Filter
						</LightBlueContainedButton>
					</Stack> 
				</Stack>*/}
				<StyledTableContainer sx={{ mt: 3 }}>
					<Table sx={{ minWidth: 650 }} aria-label="simple table" className={tableSelect.className}>
						<TableHead>
							<TableRow sx={{ backgroundColor: "#F6F6F6" }}>
								<StyledTableCellHeader align="left" sx={{ width: '16.6%' }}>Date</StyledTableCellHeader>
								<StyledTableCellHeader align="left" sx={{ width: '16.6%' }}>
									Description
								</StyledTableCellHeader>
								<StyledTableCellHeader align="left" sx={{ width: '20%' }}>Order ID</StyledTableCellHeader>
								<StyledTableCellHeader align="right" sx={{ width: '16.6%' }}>Net Sales</StyledTableCellHeader>
								<StyledTableCellHeader align="center" sx={{ width: '16.6%' }}>
									%
								</StyledTableCellHeader>
								<StyledTableCellHeader align="right" sx={{ width: '10%' }}>
									VePay Fee
								</StyledTableCellHeader>
							</TableRow>
						</TableHead>
						<TableBody>
							{isLoading ? (
								<TableRow>
									<StyledTableCellBody
										colSpan={8}
										align="center"
										sx={{ padding: "10%" }}
									>
										<CircularProgress />
									</StyledTableCellBody>
								</TableRow>
							) : (
								<>
									{vepayFeeReport.length === 0 ? (
										<TableRow>
											<StyledTableCellBody
												colSpan={8}
												align="center"
												sx={{ padding: "10%" }}
											>
												<Typography variant="h5">
													<b>No results found</b>
												</Typography>
												<Typography variant="h5_light">
													<b>From</b> {moment(value[0]).format("MMM D, y")} -&nbsp;<b>To</b>&nbsp;
													{moment(value[1]).format("MMM D, y")}
												</Typography>
											</StyledTableCellBody>
										</TableRow>
									) : (
										sortByCreatedDateTime(vepayFeeReport)
											.map((data, index) => (
												<React.Fragment key={index}>
													<TableRow hover key={index}>
														<StyledTableCellBody align="left">
															{moment(data.createdDate).format("MMM D, y")}
														</StyledTableCellBody>
														<StyledTableCellBody align="left">
															{data.description}
														</StyledTableCellBody>
														<StyledTableCellBody align="left">
															{data.ref1?.replace("AMAZON+", "")}
														</StyledTableCellBody>
														<StyledTableCellBody align="right">
															<Typography variant="amountsFont">
																{formatCurrency(data.amount2)}
															</Typography>
														</StyledTableCellBody>
														<StyledTableCellBody align="center">
															2%
														</StyledTableCellBody>
														<StyledTableCellBody align="right">
															<Typography variant="amountsFont">
																{formatCurrency(data.amount)}
															</Typography>
														</StyledTableCellBody>
													</TableRow>
												</React.Fragment>
											))
									)}
								</>
							)}

						</TableBody>
					</Table>
				</StyledTableContainer>
				<TablePagination
					rowsPerPageOptions={[10, 25, 100]}
					component="div"
					count={totalCount !== -1 ? totalCount : (totalCount === -1 ? -1 : vepayFeeReport.length)}
					rowsPerPage={rowsPerPage}
					page={page}
					onPageChange={handleChangePage}
					onRowsPerPageChange={handleChangeRowsPerPage}
				/>
			</Box>
			<br></br>
		</div>
	);
}
